import { useCallback, useState } from 'react';
import { create } from 'zustand';
import { getEnv } from '../../utils/utils';
export const useDevtools = create(set => ({
  isOpen: false,
  toggle: () => set(state => ({
    isOpen: !state.isOpen
  }))
}));
export const useShowDevtools = () => {
  return ['local', 'qa'].includes(getEnv());
};
const rhumbKey = 'REACT-RHUMB_DEBUG';
const parseRhumbValue = () => {
  try {
    const value = localStorage.getItem(rhumbKey);
    return value === 'true';
  } catch (e) {
    console.error(e);
  }
  return false;
};
export const useRhumbDebug = () => {
  const [value, setValue] = useState(parseRhumbValue());
  const setDebug = useCallback(newValue => {
    setValue(newValue);
    try {
      if (newValue) {
        localStorage.setItem(rhumbKey, newValue.toString());
      } else if (newValue === false) {
        localStorage.removeItem(rhumbKey);
      }
    } catch (e) {
      console.error(e);
    }
  }, [setValue]);
  return {
    value,
    setDebug
  };
};